export const zhTW = {
  // 導航
  nav: {
    home: '首頁',
    transport: '交通接駁',
    stay: '住宿推薦',
    tickets: '行程票券',
    cowork: '工作空間',
    culture: '文化體驗',
    nomad: '數位游牧社群',
  },
  
  // 首頁
  home: {
    hero: {
      title: '花蓮數位游牧整合平台',
      subtitle: '探索花蓮的自然美景，享受完美的數位工作環境',
      cta: '開始探索',
    },
    quickNav: {
      title: '快速導覽',
      transport: '交通接駁',
      stay: '住宿推薦',
      tickets: '行程票券',
      cowork: '工作空間',
      culture: '文化體驗',
    },
    featured: {
      title: '推薦活動',
      summerFestival: '花蓮夏季節慶',
      whaleWatching: '賞鯨體驗',
      hiking: '太魯閣健行',
    },
  },
  
  // 交通頁面
  transport: {
    title: '交通與接駁預約',
    fromTaipei: '從台北到花蓮',
    toAccommodation: '花蓮機場到住宿接駁',
    rental: '租車服務',
    methods: {
      hsr: '高鐵 + 接駁',
      train: '台鐵',
      plane: '飛機',
    },
    form: {
      departure: '出發地',
      destination: '目的地',
      date: '日期',
      time: '時間',
      passengers: '人數',
      vehicleType: '車種',
      duration: '租期',
      submit: '預約',
    },
  },
  
  // 住宿頁面
  stay: {
    title: '住宿推薦',
    filters: {
      price: '價位',
      type: '類型',
      nomadFriendly: '數位游牧友善',
      all: '全部',
      hotel: '飯店',
      hostel: '青旅',
      homestay: '民宿',
    },
    card: {
      perNight: '每晚',
      wifi: 'Wi-Fi',
      longTerm: '長租折扣',
      viewDetails: '查看詳情',
    },
  },
  
  // 票券頁面
  tickets: {
    title: '行程票券',
    addToCart: '加入購物車',
    selectDate: '選擇日期',
    selectTime: '選擇時段',
    participants: '人數',
    meetingPoint: '集合地點',
    price: '票價',
    bookNow: '立即預約',
  },
  
  // 工作空間頁面
  cowork: {
    title: '共用工作空間',
    daily: '日租',
    weekly: '週租',
    monthly: '月租',
    features: {
      wifi: 'Wi-Fi',
      power: '插座',
      meeting: '會議室',
      coffee: '咖啡供應',
    },
    speed: '網速',
    hours: '開放時間',
  },
  
  // 文化體驗頁面
  culture: {
    title: '在地文化體驗',
    book: '預約',
    maxParticipants: '人數上限',
    languages: '語言支援',
    timeSlots: '可預約時段',
  },
  
  // 社群頁面
  nomad: {
    title: '數位游牧社群',
    events: '活動列表',
    interested: '有興趣參加',
    comment: '留言',
    languageExchange: '語言交換',
    workMeetup: '工作聚會',
  },
  
  // 使用者選單
  user: {
    login: '登入',
    logout: '登出',
    profile: '個人資料',
    language: '語言',
    chinese: '繁體中文',
    english: 'English',
  },
  
  // 通用
  common: {
    loading: '載入中...',
    error: '發生錯誤',
    success: '成功',
    cancel: '取消',
    confirm: '確認',
    back: '返回',
    next: '下一步',
    search: '搜尋',
    filter: '篩選',
    sort: '排序',
  },
}; 